import { LanguageEnum } from "../enums/common/LanguageEnum.ts";

const LOCALE_BY_LANGUAGE: Record<LanguageEnum, string> = {
  [LanguageEnum.CS]: "cs-CZ",
  [LanguageEnum.EN]: "en-GB",
};

export function languageToLocale(language: LanguageEnum): string {
  return LOCALE_BY_LANGUAGE[language];
}
